export interface LineTapCandidate {
  sectionId: string;
  lineIndex: number;
  x: number;
  y: number;
  time: number;
}

const DOUBLE_TAP_MAX_INTERVAL_MS = 450;
const DOUBLE_TAP_MAX_DISTANCE_PX = 24;

export function isLineDoubleTap(previous: LineTapCandidate | null, current: LineTapCandidate): boolean {
  if (!previous) return false;

  return previous.sectionId === current.sectionId
    && previous.lineIndex === current.lineIndex
    && current.time >= previous.time
    && current.time - previous.time <= DOUBLE_TAP_MAX_INTERVAL_MS
    && Math.hypot(current.x - previous.x, current.y - previous.y) <= DOUBLE_TAP_MAX_DISTANCE_PX;
}